import { IconButton, Tooltip } from "@mui/material";
import { FC, memo } from "react";
import { FaPaperclip, FaTrash } from "react-icons/fa";
import styled from "styled-components";
import { useChat } from "../../../hooks/useChat";

const FileItemWrapper = styled("div")<{ $itemHeight: number }>`
  height: ${(props) => props.$itemHeight}px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: rgba(224, 217, 227, 0.43);
  }
`;

const FileName = styled("div")`
  padding: 4px 8px;
  box-sizing: border-box;
  width: 100%;
  color: ${(props) => props.theme.colors.primary};
  display: flex;
  align-items: center;
  gap: 5px;
`;

const RemoveButton = styled("div")`
  padding: 0 4px;
  .MuiIconButton-root {
    &:hover {
      background-color: rgba(158, 158, 158, 0.226);
    }
  }
  svg {
    fill: rgb(197, 75, 75);
  }
`;

interface IFileItemProps {
  name: string;
  extension: string;
  index: number;
  height: number;
}

const FileItem: FC<IFileItemProps> = ({ name, index, extension, height }) => {
  const { removeFile } = useChat();

  const handleRemoveItem = (itemIndex: number) => {
    removeFile(itemIndex);
  };

  return (
    <FileItemWrapper $itemHeight={height}>
      <FileName>
        <FaPaperclip size={16} />
        <span>{name + extension}</span>
      </FileName>
      <RemoveButton>
        <Tooltip title="" placement="top" arrow>
          <IconButton onClick={() => handleRemoveItem(index)}>
            <FaTrash size={12} />
          </IconButton>
        </Tooltip>
      </RemoveButton>
    </FileItemWrapper>
  );
};

export default memo(FileItem);
